import React from 'react';
import PropTypes from 'prop-types';

import './global-nav.less';

const GlobalNav = ({ logoTarget }) => (
  <div className="global-nav-mask">
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
    <div
      className="global-nav-mask-logo"
      onClick={() => {
        window.location = logoTarget;
      }}
    />
  </div>
);

GlobalNav.displayName = 'GlobalNav';

GlobalNav.propTypes = {
  logoTarget: PropTypes.string,
};

GlobalNav.defaultProps = {
  logoTarget: '/',
};

export default GlobalNav;
